import { render } from "./logout.vue?vue&type=template&id=2c1f2460"
import script from "./logout.js?vue&type=script&lang=js&external"
export * from "./logout.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__